/** Insert text into a reply body: over the selection when there is one, else after a blank line at the end. */
export type Selection = { start: number; end: number }

export function insertAt(body: string, text: string, sel: Selection | null): { body: string; cursor: number } {
  if (sel) {
    const start = Math.min(Math.max(0, sel.start), body.length)
    const end = Math.min(Math.max(start, sel.end), body.length)
    return { body: body.slice(0, start) + text + body.slice(end), cursor: start + text.length }
  }
  const head = body.replace(/\n+$/, '')
  const next = head ? `${head}\n\n${text}` : text
  return { body: next, cursor: next.length }
}
